import React from 'react'
import {
    Wrapper,
    SkeletonTable, SkeletonBar,
    SkeletonHeading,
    SkeletonPie,
    SkeletonLegends, SkeletonLegend,
    SkeletonRow
} from './s'

const SkeletonLoader = () => (
    <Wrapper>
        <SkeletonTable>
            <SkeletonHeading />
            <SkeletonPie />
            <SkeletonRow>
                <span />
            </SkeletonRow>
            <SkeletonRow>
                <span />
            </SkeletonRow>
            <SkeletonRow>
                <span />
            </SkeletonRow>
        </SkeletonTable>
        <SkeletonBar>
            <SkeletonHeading />
            <SkeletonLegends>
                <SkeletonLegend>
                    <span />
                </SkeletonLegend>
                <SkeletonLegend>
                    <span />
                </SkeletonLegend>
                <SkeletonLegend>
                    <span />
                </SkeletonLegend>
            </SkeletonLegends>
            <SkeletonRow>
                <span />
            </SkeletonRow>
            <SkeletonRow>
                <span />
            </SkeletonRow>
            <SkeletonRow>
                <span />
            </SkeletonRow>
            <SkeletonRow>
                <span />
            </SkeletonRow>
        </SkeletonBar>
    </Wrapper>
)

export default SkeletonLoader
